import * as React from 'react';
import GhostInput from '../../GhostInput';
import {styled, px} from '../../../utils';
import {padding, placeholder} from 'polished';

const HEIGHT = 55;

const Main = styled('input')(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: theme.fontSize.large,
  width: '100%',
  boxSizing: 'border-box',
  border: 0,
  borderTop: '1px solid #ccc',
  height: HEIGHT,
  lineHeight: px(HEIGHT),
  ...padding(0, 20),
  ...placeholder({color: '#7E8DA6'})
}));

export default class ChatInput extends React.Component<React.InputHTMLAttributes<{}>, {}> {
  public render() {
    return (
      <div>
        <Main type="text" {...this.props} />

        {/* Submit button */}
        <GhostInput type="submit" value="Submit" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ChatUI/ChatInput/ChatInput.tsx